// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import {
  type DefaultErrorResponse,
  DefaultErrorResponseFromJSON,
  DefaultErrorResponseToJSON,
} from "../models/DefaultErrorResponse";
import {
  type OGC3DTileset,
  OGC3DTilesetFromJSON,
  OGC3DTilesetToJSON,
} from "../models/OGC3DTileset";
import {
  type ValidationErrorResponse,
  ValidationErrorResponseFromJSON,
  ValidationErrorResponseToJSON,
} from "../models/ValidationErrorResponse";

export interface GetOgc3dTilesetFileRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  fileDescriptorId: string;
  /**
   *
   */
  tilesetId: string;
  /**
   *
   */
  tilesetFilePath: string;
}

export interface GetOgc3dTilesetsRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  fileDescriptorId: string;
}

/**
 *
 */
export class Class3dTilesApi extends runtime.BaseAPI {
  /**
   * Creates request options for getOgc3dTilesetFile without sending the request
   */
  async getOgc3dTilesetFileRequestOpts(
    requestParameters: GetOgc3dTilesetFileRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling getOgc3dTilesetFile().'
      );
    }

    if (requestParameters["fileDescriptorId"] == null) {
      throw new runtime.RequiredError(
        "fileDescriptorId",
        'Required parameter "fileDescriptorId" was null or undefined when calling getOgc3dTilesetFile().'
      );
    }

    if (requestParameters["tilesetId"] == null) {
      throw new runtime.RequiredError(
        "tilesetId",
        'Required parameter "tilesetId" was null or undefined when calling getOgc3dTilesetFile().'
      );
    }

    if (requestParameters["tilesetFilePath"] == null) {
      throw new runtime.RequiredError(
        "tilesetFilePath",
        'Required parameter "tilesetFilePath" was null or undefined when calling getOgc3dTilesetFile().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", [
        "project_read",
      ]);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/tenants/{tenant_id}/file-descriptors/{file_descriptor_id}/3dtilesets/{tileset_id}/{tileset_file_path}`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace(
      "{file_descriptor_id}",
      encodeURIComponent(String(requestParameters["fileDescriptorId"]))
    );
    urlPath = urlPath.replace(
      "{tileset_id}",
      encodeURIComponent(String(requestParameters["tilesetId"]))
    );
    urlPath = urlPath.replace(
      "{tileset_file_path}",
      encodeURIComponent(String(requestParameters["tilesetFilePath"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Endpoint to retrieve tile.json or subtree path files for an OGC 3D tileset.
   * retrieve tileset.json or subtree path files (*.b3dm) for an OGC 3D tileset
   */
  async getOgc3dTilesetFileRaw(
    requestParameters: GetOgc3dTilesetFileRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<any>> {
    const requestOptions = await this.getOgc3dTilesetFileRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    if (this.isJsonMime(response.headers.get("content-type"))) {
      return new runtime.JSONApiResponse<any>(response);
    } else {
      return new runtime.TextApiResponse(response) as any;
    }
  }

  /**
   * Endpoint to retrieve tile.json or subtree path files for an OGC 3D tileset.
   * retrieve tileset.json or subtree path files (*.b3dm) for an OGC 3D tileset
   */
  async getOgc3dTilesetFile(
    requestParameters: GetOgc3dTilesetFileRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<any> {
    const response = await this.getOgc3dTilesetFileRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for getOgc3dTilesets without sending the request
   */
  async getOgc3dTilesetsRequestOpts(
    requestParameters: GetOgc3dTilesetsRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling getOgc3dTilesets().'
      );
    }

    if (requestParameters["fileDescriptorId"] == null) {
      throw new runtime.RequiredError(
        "fileDescriptorId",
        'Required parameter "fileDescriptorId" was null or undefined when calling getOgc3dTilesets().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", [
        "project_read",
      ]);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/tenants/{tenant_id}/file-descriptors/{file_descriptor_id}/3dtilesets`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace(
      "{file_descriptor_id}",
      encodeURIComponent(String(requestParameters["fileDescriptorId"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * retrieve a list of OGC 3D tilesets for this file descriptor
   */
  async getOgc3dTilesetsRaw(
    requestParameters: GetOgc3dTilesetsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Array<OGC3DTileset>>> {
    const requestOptions = await this.getOgc3dTilesetsRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(OGC3DTilesetFromJSON)
    );
  }

  /**
   * retrieve a list of OGC 3D tilesets for this file descriptor
   */
  async getOgc3dTilesets(
    requestParameters: GetOgc3dTilesetsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Array<OGC3DTileset>> {
    const response = await this.getOgc3dTilesetsRaw(requestParameters, initOverrides);
    return await response.value();
  }
}
